/* Importing the necessary libraries and files */
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

/* Importing the components from the material-ui library. */
import { Breadcrumbs, Container, Grid, Link, Stack, Typography } from '@mui/material';

/* Importing components. */
import Page from '../../components/Page';
import SelectDevice from '../../sections/meeting/meeting.section.new';
import CallPatient from '../../sections/meeting/meeting.section.patient';

/**
 * Renders the MeetingNew component.
 * 
 * @returns {JSX.Element} The rendered MeetingNew component.
 */
export default function MeetingNew() {
  const [title] = useState('Meeting');

  return (
    <Page title={title}>
      <Container maxWidth="none">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Stack direction="column" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              {title}
            </Typography>
            <Breadcrumbs aria-label="breadcrumb" mr={4}>
              <Link underline="hover" color="inherit" component={RouterLink} to="/patient/list">
                Create New Meeting
              </Link>
            </Breadcrumbs>
          </Stack>
        </Stack>

        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={6} md={3}>
            <SelectDevice />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <CallPatient />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
